import moment, {Moment} from 'moment-timezone'
import {isOctoberRestrictionEnabled} from '@/constants/dateRangePresets'
import {disabledDatesBeforeOctober2025} from '@/utils/moment-utils'

export const isDateDisabled = (
    currentDate: Moment,
    selectedDates: Moment[],
    rangeType: 'start' | 'end',
    isCalendarChanged?: boolean,
    isDateClicked?: boolean
) => {
    if (!currentDate) return false

    const today = moment()

    const absMaxRangeDate =
        selectedDates && selectedDates[0]?.clone().add(30, 'day').isAfter(today)
            ? today
            : selectedDates[0]?.clone().add(30, 'day')

    if (!rangeType) {
        if (isDateClicked && !isCalendarChanged) {
            return currentDate.isAfter(absMaxRangeDate)
        }

        return isOctoberRestrictionEnabled
            ? disabledDatesBeforeOctober2025(currentDate) || currentDate.isAfter(today)
            : currentDate.isAfter(today)
    }

    if (rangeType === 'start' && selectedDates && selectedDates[0]) {
        const minRangeDate = selectedDates && selectedDates[0]?.clone().subtract(30, 'day')

        return currentDate.isBefore(minRangeDate) || currentDate.isAfter(absMaxRangeDate)
    }

    if (rangeType === 'end' && selectedDates && selectedDates[1]) {
        const maxRangeDate = selectedDates && selectedDates[1]
        const minRangeDate = selectedDates && selectedDates[1]?.clone().subtract(30, 'day')

        return currentDate.isBefore(minRangeDate) || currentDate.isAfter(maxRangeDate)
    }

    return currentDate.isAfter(absMaxRangeDate, 'day')
}
